/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }
var expressCheckoutBtns;

// FS cross-sell popup start
const fsCrossModal = {
  callOpen: () => {
    fsCrossModal.opener = document.activeElement;
    openFsCrossModal();
  },
  callClose: () => {
    closeFsCrossModal(fsCrossModal.opener);
  },
  handleOverlayClick: (event) => {
    if (event.target.className === 'fs-cross-popup-overlay'){
      closeFsCrossModal(fsCrossModal.opener);
    }
  }
}

function openFsCrossModal(){
  setVisibile(true);
  setFocus();
  setInertBehindModal(true);
}

function closeFsCrossModal(opener = false) {
  const featImg = document.querySelector('#section-fs-cross-popup .product-recommendation__wrapper .product-added .image-wrapper img');
  const varNameEl = document.querySelector('#section-fs-cross-popup .product-recommendation__wrapper .product-added .info-wrapper h4');
  featImg && featImg.remove();
  varNameEl && varNameEl.remove();
  document.getElementById("product-recommendation-popup__slider").classList.remove('slick-initialized');
  setVisibile(false);
  setInertBehindModal(false);
  opener && opener.focus();
}

function attachEventListener(closeButtons, overlay) {
  closeButtons.forEach(b => {
    b.addEventListener('click', fsCrossModal.callClose);
  });
  overlay.addEventListener('click', fsCrossModal.handleOverlayClick);
  window.addEventListener('keydown', clallIfEscPress);
}

function setVisibile(visible) {
  const display = visible? 'flex' : 'none';
  document.querySelector('.fs-cross-popup-overlay').style.display = display;
}

function setFocus() {
  document.querySelectorAll('.popup button, .popup input, .popup textarea, .popup select')[0].focus();
}

function setInertBehindModal(inert) {
  if (inert) {
    document.body.classList.add('js-drawer-open');
  } else {
    document.body.classList.remove('js-drawer-open');
  }
  const element = document.querySelector('main');
  element.inert = inert;
  element.setAttribute('aria-hidden', inert);
}

function clallIfEscPress(event){
  if (event.key === 'Escape') {
    fsCrossModal.callClose();
  }
  }

  function clearValidationErrors() {
    const errorWrapper = document.getElementById('generic-cart-error');
    errorWrapper.innerText = '';
    errorWrapper.classList.add('visually-hidden');
 
    const lineErrorWrappers = Array.from(document.getElementsByClassName('cart-line-error'));

    lineErrorWrappers.forEach(lineErrorWrapper => {
      lineErrorWrapper.innerText = '';
      lineErrorWrapper.classList.remove('product-flag', 'qty');
    });
  }

  function handleValidationError(errorMessage) {
    if (errorMessage.includes('VALIDATION:')) {
      setTimeout(function() {
        let errorWrapper = document.getElementById('generic-cart-error');

        const displayErrorMessage = formatValidationMessage(errorMessage);

        const cartLine = errorMessage.match(/LINE:([0-9]+)/);  
        if(cartLine) errorWrapper = document.getElementById(`cart-${cartLine[1]}-error`);

        errorWrapper.classList.add('product-flag', 'qty');
        errorWrapper.classList.remove('visually-hidden');

        errorWrapper.innerText = displayErrorMessage;
      }, 500);
    }
  }

  const formatValidationMessage = message => message.includes('VALIDATION:') ? message.match(/'([^']+)'/)[1] : message;


const closeButtons = document.querySelectorAll('.close-fs-cross-popup');
const overlay = document.querySelector('.fs-cross-popup-overlay');
attachEventListener(closeButtons, overlay);
// FS cross-sell popup end

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  clearValidationErrors();
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');

  if (!!data.message) {
    const errorMessage = XMLHttpRequest?.responseJSON?.message ?? ''; 

    if (errorMessage.includes('VALIDATION:')) handleValidationError(errorMessage);

    console.error(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  clearValidationErrors();
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback, pid = false, prodName = false, featImg = false, varName = false, openDrawer = false) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
    if (pid && prodName && featImg && !openDrawer) {
      fetchCrosssellPopup(pid, prodName, featImg, varName);
      openFsCrossModal();
    }
    if (openDrawer) {
      closeFsCrossModal();
    }
  });
};

Shopify.changeItemLine = function(line, quantity, callback) {
  clearValidationErrors();
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity='+quantity+'&line='+line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
        console.log("line item changed");
      }
      else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      console.log("here we are sold out" +textStatus );
      if (textStatus.includes("sold out")){
        textStatus =  textStatus +" and will be removed";          
        console.log("Removed text");
      }
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  clearValidationErrors();
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {

      console.log("here we are sold out" + textStatus+ " 2" + XMLHttpRequest);
      if (XMLHttpRequest.responseJSON.message.includes("sold out")){
        textStatus =  textStatus +" and will be removed2";          
        const soldOutItem = document.querySelector(`.ajaxcart__product [data-line="${line}"]`);
        soldOutItem.querySelector('.drawer-text-item-price').innerText = 'Out of Stock';
        soldOutItem.querySelector('.display-table .ajaxcart__edit').classList.add('hidden');
        soldOutItem.querySelector('.ajaxcart__qty-num').disabled = true;
        soldOutItem.querySelector('.ajaxcart__qty--plus').disabled = true;
        const soldoutEl = document.createElement('p');
        soldoutEl.classList.add('alert');
        soldoutEl.innerText = 'Please remove item or select a new shade';
        soldOutItem.querySelector('.product-info').appendChild(soldoutEl);
        document.querySelector('.cart__checkout.btn-minicart').disabled = true;
        } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart, setTrigger, scrollToTrigger,closeCart;

  // Private general variables
  var settings, isUpdating, $body, triggerObject;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty,giftWithPurchaseCallback,get_cart_token,get_ga_linker;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {
    $body = $('body');
    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true,
      shop_permanent_domain : ''
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };loadCart = function (openDrawer = false, pid = false, prodName = false, featImg = false, varName = false) {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cart => cartUpdateCallback(cart, openDrawer), pid, prodName, featImg, varName, openDrawer);
  };

  $('#AddToCart').on('click', function() {
    triggerObject = this;
  });

  setTrigger = function(trigger) {
    triggerObject = trigger;
  };

  scrollToTrigger = function() {
    let haveTrigger = () => {
      if (triggerObject) {
        if (typeof triggerObject.focus === "function") { 
          triggerObject.focus({preventScroll:false});
          triggerObject = null;
          return false;
        }
      }
      triggerObject = null;
      return true;
    };
    if (haveTrigger()){
      $('.js-drawer-open-right').focus();
    }
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {    
      $cartCountSelector.html(cart.item_count);
      $cartCountSelector.removeClass('hidden-count');      
 	  if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(cart.total_price/100);
      calc_shipping(cart.total_price);
    }
  };

  formOverride = function () {
    console.log('form override');
    $formContainer.on('submit', function(evt) {      
      evt.preventDefault();      
      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product, form) {_learnq = _learnq || [];
  _learnq.push(['track', 'Added to Cart',product]);dataLayer.push({"event":"EEaddToCart",
        "ecommerce": {
        "currencyCode":"USD",
        "add": {
          "products": [{
          "id":product.id,
          "sku":product.sku,
          "name":product.title,
          "productPrice":product.price * 0.01 ,
          "price":product.price * 0.01 ,
          "line_price":product.price * 0.01 * form.quantity.value,
          "list_price": product.original_price* 0.01 ,
          "brand":product.vendor,
          "category":"cosmetics",
          "variant":product.title, 
          "quantity":form.quantity.value
        }]
        }
        }
  });

    $addToCart.removeClass('is-adding').addClass('is-added');



  ShopifyAPI.getCart(cartUpdateCallback, product.product_id, product.product_title.split(" - ")[0], product.image, product.variant_title);    
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        const formattedMessage = formatValidationMessage(data.message);

        const errorMessageWrapper = document.getElementById('form-error-message');

        if (errorMessageWrapper) {
          errorMessageWrapper.innetText = formattedMessage
        } else { 
          $formContainer.after(`<div id="form-error-message" class="product-flag qty">${formattedMessage}</div>`)
        }

        loadCart(true);
        handleValidationError(data.message);
      }
    }
  };

  cartUpdateCallback = function (cart, openDrawer = false) {
    buildCart(cart, openDrawer);
    sleep(300);
    // Update quantity and price
    ShopifyAPI.getCart(cart => updateCountPrice(cart));
  };

  

    const cartHasSpecificPromoGift = (promoId, cart) => cart.items.some(function(item){
        if(item.properties !== null){
          return item.properties["_promoId"] == promoId;
        }
        return false;
      });

    const cartHasQualifierProduct = (qualifiersId, cart) => {
      let qualifierProd = false;
      cart.items.find((item) => {
        if (qualifiersId.includes(item.variant_id) && (!item.properties || (item.properties && !item.properties["_giftWithPurchase"]))) {
          qualifierProd = item.variant_id;
        }
      });
      return qualifierProd;
    }

    const removeGwpByPromoId = (promoId, cart) => {
      const lineIndex = cart.items.findIndex(i => i.properties["_promoId"] == promoId);
      if (lineIndex >= 0) Shopify.changeItemLine((lineIndex + 1), 0, adjustCartCallback);
    }

    const removeGwpByVariantId = (promoId, variantId, cart) => {
      const lineIndex = cart.items.findIndex(i => i.properties["_promoId"] == promoId && i.variant_id == variantId);
      
      if (lineIndex >= 0) Shopify.changeItemLine((lineIndex + 1), 0, adjustCartCallback);
    }
  
    const buildItemToAdd = (promoId, gwpId) => {
      let props = { "_giftWithPurchase": "true" };
      props["_promoId"] = promoId;
      
      return {
        id: gwpId,
        quantity: 1,
        properties: props
      }
    }
    
    const buildItemToRemove = (promoId, gwpId) => {
      return {
        variantId: gwpId,
        promoId: promoId
      }   
    }

    const handleProductGwp = (gwpSettings, cart) => {
      const returnObject = {
        itemsToAdd: [],
        itemsToRemove: [],
        qualifierToUpdate: '',
        promoId: ''
      }

      const cartHasQualifier = cartHasQualifierProduct(gwpSettings.qualifiers, cart);
      const cartHasGwp = cartHasSpecificPromoGift(gwpSettings.promoId, cart);

      if (cartHasQualifier) {
        if (!cartHasGwp) {
          returnObject.itemsToAdd.push(buildItemToAdd(gwpSettings.promoId, gwpSettings.gwpId));
          returnObject.qualifierToUpdate = cartHasQualifier;
          returnObject.promoId = gwpSettings.promoId;
        }
      } else {
        if (cartHasGwp) {
          returnObject.itemsToRemove.push(buildItemToRemove(gwpSettings.promoId, gwpSettings.gwpId))
        }
      }

      return returnObject;
    }

    const handleThresholdGwp = (gwpSettings, cart) => {
      const returnObject = {
        itemsToAdd: [],
        itemsToRemove: []
      };

      const cartTotalWithoutGwps = cart.items.reduce((acc, cv) => {
          let toSum = 0;

          if (!cv.properties || cv.properties["_promoId"] == null) {
            //uses original_line_price since Shopify is sending 
            //totalAmount without discounts via Discounts Function GraphQL API
            toSum = cv.original_line_price//line_price
          }
          return acc + toSum;

      }, 0);

      gwpSettings.forEach(setting => {
        const cartValueAboveThreshold = cartTotalWithoutGwps >= (setting.qualifiers * 100);
        const cartHasGwp = cartHasSpecificPromoGift(setting.promoId, cart);


        if (cartValueAboveThreshold) {
          if (!cartHasGwp) {
            returnObject.itemsToAdd.push(buildItemToAdd(setting.promoId, setting.gwpId));
          }
        } else {
          if (cartHasGwp) {
            returnObject.itemsToRemove.push(buildItemToRemove(setting.promoId, setting.gwpId));
          }
        }
      });

      return returnObject;
    };

    const handleTierThresholdGwp = (gwpSettings, cart) => {
      const returnObject = {
        itemsToAdd: [],
        itemsToRemove: []
      }

      const cartTotalWithoutGwps = cart.items.reduce((acc, cv) => {
          let toSum = 0;

          if (!cv.properties || cv.properties["_promoId"] == null) {
            //uses original_line_price since Shopify is sending 
            //totalAmount without discounts via Discounts Function GraphQL API
            toSum = cv.original_line_price//line_price
          }
          return acc + toSum;

      }, 0);

      let qualifiedTier = gwpSettings.filter(s => cartTotalWithoutGwps >= (s.qualifiers * 100)).sort((a, b) => b.qualifiers - a.qualifiers)[0];

      const promoId = gwpSettings[0].promoId;
      const cartHasGwp = cartHasSpecificPromoGift(promoId, cart);

      if (cartHasGwp) {
        const cartPromoGwps = cart.items.filter(i => {
          if (i.properties && i.properties["_promoId"] !== null) {
            return i.properties["_promoId"] == promoId;
          }
          return false;
        });

        if (typeof qualifiedTier !== 'undefined') {
          const wrongTierGwps = cartPromoGwps.filter(i => i.variant_id !== qualifiedTier.gwpId);
          wrongTierGwps.forEach(i => {
            returnObject.itemsToRemove.push(buildItemToRemove(promoId, i.variant_id));
          })

          const cartHasCurrentTierGwp = cartPromoGwps && cartPromoGwps.some(i => i.variant_id == qualifiedTier.gwpId);

          if (!cartHasCurrentTierGwp) {
            returnObject.itemsToAdd.push(buildItemToAdd(promoId, qualifiedTier.gwpId));
          }

        } else {
          cartPromoGwps.forEach(i => {
            returnObject.itemsToRemove.push(buildItemToRemove(promoId, i.variant_id));
          })
        }
      } else {
        if (typeof qualifiedTier !== 'undefined') { 
          returnObject.itemsToAdd.push(buildItemToAdd(promoId, qualifiedTier.gwpId));
        }
      }

      return returnObject;
    }

    const groupByPromoId = jsonGwpSettings => {
      const groupedObj = jsonGwpSettings.reduce((group, settings) => {
        const { promoId } = settings;
        group[promoId] = group[promoId] ?? [];
        group[promoId].push(settings);
        return group;
      }, {});
      return Object.values(groupedObj).map(i => i);
    }

  const updateCartGwps = async (itemsToAdd = [], itemsToRemove = [], qualifierToUpdate = '', promoId = '', cart, callback = {}) => {
    let newCart = cart;

    clearValidationErrors();

    if (itemsToAdd.length > 0) { 
      newCart = await $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: { items: itemsToAdd },
        success: async function(cart) {
          if (qualifierToUpdate !== '' && promoId !== '') {
            const qualifierItem = newCart.items.find(i => i.id == qualifierToUpdate);
            let propertiesJson = {};
            propertiesJson = {
              '_promoId': promoId
            }
            newCart = await $.ajax({
              url: '/cart/change.js',
              dataType: 'json',
              type: 'post',
              data: {
                'id': qualifierItem.key,
                'properties': propertiesJson
              },
              success: function(cart) {
                return cart;
              },
              error: function(XMLHttpRequest, textStatus) {
                console.error('Error:', textStatus);
              }
            })
          } else {
            return cart;
          }
        },
        error: function(XMLHttpRequest, textStatus) {
          //Shopify.onError(XMLHttpRequest, textStatus);
          // add throw statement for gwp
          console.log("Sold out of GWP");
        }
      })
    }

    const cartLinesToRemove = cart.items.filter(li => {
      if (li.properties && li.properties["_giftWithPurchase"] == "true") {
        if (itemsToRemove.some(i => li.properties["_promoId"] !== undefined && li.variant_id == i.variantId)) {
          return true;
        }
      }
      return false;
    });

    const cartLinePropertyToRemove = cart.items.find(li => {
      if (li.properties && li.properties["_promoId"] !== undefined && li.properties["_giftWithPurchase"] != "true") {
        if (!cart.items.some(i => i.properties["_giftWithPurchase"] == "true")) {
          return true;
        }
      }
      return false;
    });
    
    if (cartLinePropertyToRemove) {
      let propertiesJson = {};
      propertiesJson = {
        '_promoId': null
      }
      newCart = await $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        type: 'post',
        data: {
          'id': cartLinePropertyToRemove.key,
          'properties': propertiesJson
        },
        success: function(cart) {
          return cart;
        },
        error: function(XMLHttpRequest, textStatus) {
          console.error('Error:', textStatus);
        }
      })
    }

    itemsToRemove = cartLinesToRemove.map(i => {
      return {
        [i.key]: 0 
      }
    });

    if (itemsToRemove.length > 0) { 
      let data = {};
      Object.assign(data, ...itemsToRemove);
      newCart = await $.ajax({
            url: '/cart/update.js',
            dataType: 'json',
            type: 'post',
            data: { updates: data },
        success: function(cart) {
          return cart;
        },
        error: function(XMLHttpRequest, textStatus) {
          Shopify.onError(XMLHttpRequest, textStatus);
        }
      });
    }

    if (itemsToAdd.length > 0 || itemsToRemove.length > 0 || cartLinePropertyToRemove) {
      if ((typeof callback) === 'function') {
        callback(newCart);
      }
    }

  }

  const updateGwpReceivedText = (cart, gwpSettings) => {
    const cartValue = cart.total_price;
    const cartProductIds = cart.items.map(item => item.variant_id); 

    const nextGwpTextElement = document.querySelector('.gwp_next span');
    const gwpReceivedTextElement = document.querySelector('.gwp_received span');

    if (nextGwpTextElement) {
        // Separate promotions by type
        const thresholdPromos = gwpSettings.filter(promo => promo.type === 'threshold');
        const productPromos = gwpSettings.filter(promo => promo.type === 'product');

        // Sort thresholdPromos by qualifiers
        thresholdPromos.sort((a, b) => a.qualifiers - b.qualifiers);

        let currentGwp = null;
        let nextGwp = null;

        // Logic for threshold promotions
        for (let i = 0; i < thresholdPromos.length; i++) {
            if (cartValue >= (thresholdPromos[i].qualifiers * 100)) {
                currentGwp = thresholdPromos[i];
            } else if (!nextGwp && cartValue < (thresholdPromos[i].qualifiers * 100)) {
                nextGwp = thresholdPromos[i];
            }
        }

        // Logic for product promotions
        for (let i = 0; i < productPromos.length; i++) {
            if (productPromos[i].qualifiers.some(id => cartProductIds.includes(id))) {
                currentGwp = productPromos[i];
                document.querySelector('.p-bar-wrapper').style.display = 'none';
                document.querySelector('.gwp_next').style.display = 'none';
                break; // Assuming only one product promo can be applied
            } else if (!nextGwp && !productPromos[i].qualifiers.some(id => cartProductIds.includes(id))) {
                nextGwp = productPromos[i];
            }
        }

        // Update received GWP message display
        if (currentGwp) {
            document.querySelector('.gwp_received').style.display = "flex";
            gwpReceivedTextElement.innerText = `${currentGwp.receivedMessage}`;
            $('.p-bar-wrapper').html('<span class="p-bar" style="width: 100%"></span>');
            $('.p-bar-wrapper').attr('aria-valuenow', 100);
        } else {
            document.querySelector('.gwp_received').style.display = "none";
        }

        // Update next GWP message display for threshold promotions
        if (nextGwp && nextGwp.type === 'threshold') {
            document.querySelector('.gwp_next').style.display = "flex";
            let remainingValue = Math.floor((nextGwp.qualifiers * 100 - cartValue) / 100);
            var percent_left = (cartValue / (nextGwp.qualifiers * 100)) * 100;
            $('.p-bar-wrapper').html('<span class="p-bar" style="width: ' + percent_left + '%"></span>');
            $('.p-bar-wrapper').attr('aria-valuenow', cartValue / 100);
            $('.p-bar-wrapper').attr('aria-valuemax', nextGwp.qualifiers);

            let nextMessage = nextGwp.message?.replace('${remainingValue}', remainingValue);
            nextGwpTextElement.innerText = nextMessage;
        } else if (nextGwp && nextGwp.type === 'product') {
            document.querySelector('.gwp_next').style.display = "none";
            $('.p-bar-wrapper').html('<span class="p-bar" style="display: none;"></span>');
            let nextMessage = nextGwp.message;
            nextGwpTextElement.innerText = nextMessage;
            document.querySelector('.gwp_next').style.display = "none";
        } else {
            document.querySelector('.gwp_next').style.display = "none";
        }
    }
  };

  giftWithPurchaseCallback = function( cart ){

    let gwpSettingsTestApp = document.getElementById('formaGwp')?.dataset?.formaGwp ?? '';
    const jsonSettings = JSON.parse(gwpSettingsTestApp);
    let jsonGwpSettings;
    if (jsonSettings.gwpSettings && Array.isArray(jsonSettings.gwpSettings)) {
      jsonGwpSettings = jsonSettings.gwpSettings;
    }

    // Group Settings by promoId to handle tier threshold
    const groupedSettingsByPromoId = jsonGwpSettings && groupByPromoId(jsonGwpSettings);

    let normalGwpResult;
    let thresholdGwpResult = [];
    let tierThresholdGwpResult = [];
    let qualifierToUpdate = '';
    let promoId = '';

    let gwpResult = {
      itemsToAdd: [],
      itemsToRemove: []
    }

    let oldPromoItems; 
    const startDate = new Date(jsonSettings.startDate);
    const endDate = new Date(jsonSettings.endDate);
    const currentDate = new Date();

    const isPromoEnabled = currentDate > startDate && currentDate < endDate;

    if(isPromoEnabled) {
      // Call respective handlers based on GWP type and count of grouped by ID
      groupedSettingsByPromoId && groupedSettingsByPromoId.forEach(gwpSettings => {
        if (gwpSettings.length > 1) {
          if (gwpSettings[0].type == 'threshold') {
            tierThresholdGwpResult.push(handleTierThresholdGwp(gwpSettings, cart));
            updateGwpReceivedText(cart, gwpSettings);
          }
        } else {
          if (gwpSettings[0].type == 'threshold') {
            thresholdGwpResult.push(handleThresholdGwp(gwpSettings, cart));
            updateGwpReceivedText(cart, gwpSettings);
          } else {
            if (gwpSettings[0].type == 'product') {
              normalGwpResult = handleProductGwp(gwpSettings[0], cart);
              document.querySelector(".p-bar-wrapper") && (document.querySelector(".p-bar-wrapper").style.display = "none");
            }
          }
        }
      });
  
      gwpResult.itemsToAdd = gwpResult.itemsToAdd
                              .concat(normalGwpResult?.itemsToAdd)
                              .concat(thresholdGwpResult.flat().map(result => result.itemsToAdd || []).flat())
                              .concat(tierThresholdGwpResult.flat().map(result => result.itemsToAdd || []).flat());
     
      gwpResult.itemsToRemove = gwpResult.itemsToRemove
                                  .concat(normalGwpResult?.itemsToRemove)
                                  .concat(thresholdGwpResult.flat().map(result => result.itemsToRemove || []).flat())
                                  .concat(tierThresholdGwpResult.flat().map(result => result.itemsToRemove || []).flat());   

      oldPromoItems = cart.items.filter(li => {
        return li.properties && li.properties["_giftWithPurchase"] == "true" && !jsonGwpSettings.some(s => li.variant_id === s.gwpId);
      });

      } else {

        oldPromoItems = cart.items.filter(li => li.properties["_giftWithPurchase"] == "true");
        document.querySelector('.p-bar-wrapper').style.display = 'none';
       // document.querySelector('.gwp_next').style.display = "none";
     }

    gwpResult.itemsToRemove = gwpResult.itemsToRemove.concat(oldPromoItems.map(o => buildItemToRemove(o.properties[0], o.variant_id)));

    const itemsToAdd = gwpResult.itemsToAdd.filter(i => i !== undefined);
    const itemsToRemove = gwpResult.itemsToRemove.filter(i => i !== undefined);
    qualifierToUpdate = (normalGwpResult && normalGwpResult.qualifierToUpdate) ? normalGwpResult.qualifierToUpdate : '';
    promoId = (normalGwpResult && normalGwpResult.promoId) ? normalGwpResult.promoId : '';

    updateCartGwps(itemsToAdd, itemsToRemove, qualifierToUpdate, promoId, cart, adjustCartCallback);
  }

  

  
  
  

  buildCart = function (cart, openDrawer = false) {
    $("#SampleContainer").hide();
    const expressBtnsEl = document.querySelector('#CartDrawer .additional-checkout-buttons');
    if (expressBtnsEl && expressBtnsEl !== undefined) {
      expressCheckoutBtns = expressBtnsEl;
    }
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      document.querySelector('.p-bar-wrapper').style.display = 'none';
      document.querySelector('.gwp_next').style.display = 'none';
      $cartContainer
        .append('<p>' + "Your cart is currently empty." + '</p>');
        
      cartCallback(cart, openDrawer);

      return;
    } else {
      document.querySelector('.p-bar-wrapper').style.display = 'block';
    }
    giftWithPurchaseCallback(cart);hasSampleQualifyingProduct = true;// Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        hasSubscriptionItem = false,hasSampleQualifyingProduct = false,currentSampleQualVal = 0,       
      source = $("#CartTemplate").html(),
      template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {/* check for subscription  */

      /* Hack to get product image thumbnail
       *   - If image is not null
       *   - Remove file extension, add _medium, and re-add extension
       *   - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      var thisURL = cartItem.url;var isGWP = false;
      var isSample = false; //sample used for GWP and sample
      var isBundle = false;
      var isDiscounted = false;
      var isCartLimit = false;
      var isQualifier = false;

      if (cartItem.properties != null){         
        if (cartItem.properties["_giftWithPurchase"] == "true"){
          isGWP = true;
        }

        if (cartItem.properties["_promoId"] && cartItem.properties["_promoId"].includes('product') && cartItem.properties["_giftWithPurchase"] != "true") {
          isQualifier = true;
        }
      }
      
      if (cartItem.discounts.length > 0 && cartItem.discounts[0].title.toLowerCase().includes('bundle')) {
        isBundle = true;
      }

      if (cartItem.original_line_price > cartItem.line_price) {
        isDiscounted = true;
      }

      isSample = (cartItem.product_type == "Sample" ? true : false);

      // Create item's data object and add to 'items' array
      item = {
        productId: cartItem.id,
        handle: cartItem.handle,
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: thisURL,
        img: prodImg,
        name: cartItem.product_title.split(" - ")[0],
        variantName: cartItem.variant_title,
        pid:cartItem.product_id,
        sku:cartItem.sku,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        isGWP,
        isSample,
        isBundle,
        isDiscounted,
        isCartLimit: cartItem.quantity >= 5,
        isQualifier,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        vendor: cartItem.vendor
      };
      items.push(item);
    });

    var cart_value = false;
    if ( cart.total_price > 0){
      cart_value = true;
    }
    //generate checkout URL for subscriptions
    //check now wau 
    var checkout_url = 'https://checkout.rechargeapps.com/r/checkout?',
    url_params = [
      'myshopify_domain=',
    ];
    url_params = url_params
	    .concat(get_cart_token())
	    .concat(get_ga_linker());
    checkout_url = checkout_url + url_params.join('&');

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      hasValue: cart_value,
      hasSubscriptionItem: hasSubscriptionItem,
      subscriptionCheckoutURL: checkout_url
    }

    

    if (hasSampleQualifyingProduct){
      $("#SampleContainer").show();
    } else {
      $("#SampleContainer").hide();
    }
    $cartContainer.html(template(data));
    calc_shipping(cart.total_price);
    adjustCart();
    cartCallback(cart, openDrawer);
    
    
  }; // end buildCart 

  cartCallback = function(cart, openDrawer = false) {
    $body.removeClass('drawer--is-loading');
    if (openDrawer) {
      $body.trigger('ajaxCart.afterCartLoad', cart);
    }

    const minicartFooterEl = document.querySelector('#CartDrawer .ajaxcart__footer--wrapper .ajaxcart__footer.row');
    if (minicartFooterEl && !minicartFooterEl.querySelector('.additional-checkout-buttons') && expressCheckoutBtns !== undefined) {
      minicartFooterEl.appendChild(expressCheckoutBtns);
    }

    if ($('.collection-mini-carousel-slick')){
      if ($('.collection-mini-carousel-slick').length > 0 ){
        if ($('.collection-mini-carousel-slick.slick-initialized.slick-slider').length < 1){
          $('.collection-mini-carousel-slick').slick({
              accessibility: false,
              slidesToShow: 2,
              infinite: false
          });
        }
      }
    }
    
    var checkoutButton = document.getElementsByClassName('cart__checkout btn-minicart')[0];
    if (checkoutButton) {
      if (!checkoutButton.classList.contains("click-handler")) {
        checkoutButton.addEventListener('click', function(event){
          dataLayer.push({"event":"EEproceedToCart"});
        });
        checkoutButton.classList.add("click-handler");
      }
    }  
    if ($('.collection-mini-carousel-slick')){
      if ($('.collection-mini-carousel-slick').length > 0 ){
        if ($('.collection-mini-carousel-slick.slick-initialized.slick-slider').length < 1){
          $('.collection-mini-carousel-slick').slick({
              accessibility: false,
              slidesToShow: 2,
              infinite: false
          });
        }
      }
    }

    const ajaxCartGap = 16;
    const cartHeaderObserver = new MutationObserver(function (mutations, me) {
      const cartHeader = document.getElementById('cart-header');
      if (cartHeader) {
        let cartHeaderHeight = cartHeader.offsetHeight;
        if (cartHeaderHeight > 0) {
          cartHeaderHeight = cartHeaderHeight + ajaxCartGap;
          $('form.cart.ajaxcart').css({
            'max-height': `calc(100dvh - ${cartHeaderHeight}px)`,
          });
          me.disconnect(); // stop observing
          return;
        }
      }
    });

    // start observing
    cartHeaderObserver.observe(document, {
      childList: true,
      subtree: true
    });
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.off('click', '.ajaxcart__qty-adjust');
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      this.disabled = "disabled";
      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      if (qty==0) {
        $body.off('click', '.ajaxcart__qty-adjust');
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });
    //remove the line added by ps
   $body.off('click','.ajaxcart__rm');

   $body.on('click', '.ajaxcart__rm', function() {
        
      var $el = $(this),
      line = $el.data('line'); 
      $el.off('click');           

      if(typeof $el !== 'undefined'){        
        var id =  $el.data('id'); 
        var pid =  $el.data('pid'); 
        updateQuantity(line, '0');
        var mySelector = '.smpl-' + pid ;
        $(mySelector).removeClass("disabled");     	
      }
     	
   });
// ADA keystoke events
  $body.on('keypress', '.ajaxcart__rm', function(e) {
    if(e.keyCode == 9 || e.keyCode == 66 || e.keyCode == 13 || e.keyCode == 32) {
      // remove item from cart
      var $el = $(this),
      line = $el.data('line'); 
      var id =  $el.data('id'); 
     	var pid =  $el.data('pid'); 
      updateQuantity(line, 0);
      var mySelector = '.smpl-' + pid ;
      $(mySelector).removeClass("disabled");
     	var test  = document.getElementsByClassName("smpl-" + id);
    }
  });

    // Update quantity based on input on change
    $body.off('change', '.ajaxcart__qty-num');
    $body.on('change', '.ajaxcart__qty-num', function() {
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart, openDrawer = false) {
    isUpdating = false;

    // Update quantity and price
    ShopifyAPI.getCart(cart => updateCountPrice(cart));

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(cart => buildCart(cart, openDrawer));
    }, 150);
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    if (qty > 5) {
      qty = 5;
    }
    return qty;
  };



		get_cart_token =function () {
			// Build the cart_token param for the URL generator
			try {
				return ['cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2]];
			} catch (e) {
				return [];
			}
		}
		get_ga_linker = function() {
			// Build the ga_linker param for the URL generator
			try {
				return [ga.getAll()[0].get('linkerParam')];
			} catch (e) {
				return [];
			}
		}

    var itemAddedCallbackAlt = function (product , qty) {_learnq = _learnq || [];
        _learnq.push(['track', 'Added to Cart',product]);dataLayer.push({"event":"EEaddToCart",
          "ecommerce": {
          "currencyCode":"USD",
          "add": {
            "products": [{
            "id":product.sku,
            "sku":product.sku,
            "name":product.title,
            "productPrice":product.price * 0.01 ,
            "price":product.price * 0.01 ,
            "line_price":product.price * 0.01 * qty,
            "list_price": product.original_price* 0.01 ,
            "brand":product.vendor,
            "category":"cosmetics",
            "variant":product.title, 
            "quantity":qty
          }]
          }
        }
      });
    
      $addToCart.removeClass('is-adding').addClass('is-added');
    
      ShopifyAPI.getCart(cartUpdateCallback);    
    };

    var itemErrorCallbackAlt = function (XMLHttpRequest, textStatus) {
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      let $formContainer = $('form[action^="/cart/add"]');
      let $addToCart = $formContainer.find('input[type="submit"]');

      $addToCart.removeClass('is-adding is-added');
  
      if (!!data.message) {
        if (data.status == 422) {
          $formContainer.after('<div class="errors qty-error">Cannot update variant.</div>')
        }
      }
    };
    
    ShopifyAPI.addItemFromFormAlt = function(items, qty = 1, callback = itemAddedCallbackAlt, errorCallback = itemErrorCallbackAlt) {
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: items,
        dataType: 'json',
        success: function(line_item) {
          if ((typeof callback) === 'function') {
            callback(line_item, qty);
          }
        },
        error: function(XMLHttpRequest, textStatus) {
          if ((typeof errorCallback) === 'function') {
            errorCallback(XMLHttpRequest, textStatus);
          }
          else {
            ShopifyAPI.onError(XMLHttpRequest, textStatus);
          }
        }
      };
      jQuery.ajax(params);
    };

    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
  
    // Listen to message from child window
    eventer(messageEvent,function(e) {
      if (e.data.formData && e.data.itemQty) {
        console.log('parent received this message!:  ', e.data);
        ShopifyAPI.addItemFromFormAlt(e.data.formData, e.data.itemQty);
        closeQuickViewModal();
      }
    }, false);

  module = {
    init: init,
    load: loadCart,
    setTrigger: setTrigger, 
    scrollToTrigger: scrollToTrigger,
    close:closeCart
  };
  
  

  return module;

}(ajaxCart || {}, jQuery));
